import { camelizeKeys } from '@skytech/utils'

import type { Department, Policy } from '@/types'
import { get } from '@/util/auth'

import { API_ROUTE_ECOM_POLICY, API_ROUTE_ECOM_POLICY_CUSTOMER_DEPARTMENTS } from './api-routes'

export const commonEcomPolicyResources = {
  getList: async () => {
    const policies = await get<unknown>(API_ROUTE_ECOM_POLICY)
    const camelCasePolicies = camelizeKeys(policies) as (Policy & { isGlobal: 0 | 1 })[]
    const parsedPolicies = camelCasePolicies.map(policy => ({
      ...policy,
      isGlobal: Boolean(policy.isGlobal),
    }))
    return parsedPolicies
  },
  getCustomerDepartmentList: async (customerId: number) => {
    const departments = await get<unknown>(
      API_ROUTE_ECOM_POLICY_CUSTOMER_DEPARTMENTS.replace(':customerId', String(customerId))
    )
    const parsedDepartments = camelizeKeys(departments)

    return parsedDepartments as Department[]
  },
}
